import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const loginFormSelectorState = atom({
  key: "loginFormSelectorState",
  default: "login",
  effects_UNSTABLE: [ocPersistAtom],
});
